<script>
    import Home from "./pages/home/Home.svelte";
    import Resume from "./pages/resume/Resume.svelte";
    import Blog from "./pages/blog/Blog.svelte";
    import Photos from "./pages/photos/Photos.svelte";
    import {useLocation, Link} from "svelte-navigator";

    const location = useLocation();

    const pages = [
        {cmp: Home, name: 'home', link: '/', icon: 'home', title: 'Matej Kormanik'},
        {cmp: Blog, name: 'blog', link: '/blog', icon: 'blog', title: 'blog - Matej Kormanik'},
        {cmp: Photos, name: 'album', link: '/photos', icon: 'images', title: 'album - Matej Kormanik'},
        {cmp: Resume, name: 'resume', link: '/resume', icon: 'address-card', title: 'resume - Matej Kormanik'}
    ];

    let activePage = $location.pathname;
    function setActivePage(page) {
        activePage = page;
    }

    $: aTitle = pages.find(p => p.link === activePage) ? pages.find(p => p.link === activePage).title : '';
    // $: under = window.innerWidth <= 500;
</script>
<!--------------------------------------------------------------------------------------------------------------------->
<svelte:head>
    <title>{aTitle}</title>
</svelte:head>

<header>
    <div class="name">
        <Link to={pages[0].link} on:click={() => {setActivePage('/')}}>
            <span class="link-content">Matej Kormaník</span>
        </Link>
    </div>

    <nav>
        <ul>
            {#each pages as page (page.name)}
                <li>
                    <Link to={page.link} on:click={() => {setActivePage(page.link)}}>
                        <div class="under" class:active-small={activePage === page.link}>
                            <i class="fas fa-{page.icon}"></i>
                            <span>{page.name}</span>
                        </div>
                        <span class="link-content" class:active={activePage === page.link}>{page.name}</span>
                    </Link>
                </li>
            {/each}
        </ul>
    </nav>

</header>

<!--------------------------------------------------------------------------------------------------------------------->
<style>
    header {
        max-width: 1000px;
        padding: 24px 3px 20px;
        margin: 0 auto;
        background-color: var(--white-color);
        box-shadow: 1px 1px 6px 6px var(--white-color);
        z-index: 10;
        display: flex;
        justify-content: space-between;

        position: fixed;
        left: 0;
        right: 0;
    }

    .name {
        flex: 3;
        text-decoration: none;
        color: var(--dark-grey);
    }

    nav {
        flex: 2;
    }

    ul {
        padding: 0;
        display: flex;
        justify-content: space-between;
        flex-wrap: nowrap;
    }

    .link-content {
        text-decoration: none;
        color: var(--mid-grey);
        font-weight: bold;
        font-size: .9rem;
    }

    .link-content:hover {
        color: var(--black-color);
    }

    .active {
        color: var(--black-color);
        font-size: .92rem;
        text-decoration: underline;
    }

    .under {
        display: none;
    }

    /*==================================     MEDIA     ======================================*/
    @media screen and (max-width: 500px) {
        header {
            position: fixed;
            top: unset;
            left: 0;
            bottom: 0;

            width: 100vw;
            padding: 0.4rem 10px 1.1rem;
            background-color: var(--dark-grey);
        }
        .name {
            display: none;
        }
        ul {
            flex-basis: 100%;
        }

        .under {
            display: flex;
            flex-direction: column;
            color: rgb(226 219 197);
        }
        .under span {
            font-size: .9rem;
        }
        i {
            margin: 0 auto;
        }
        .link-content {
            display: none;
        }
        .active-small {
            color: var(--white-color);
        }
    }
    @media screen and (min-width: 501px) and (max-width: 1000px) {
        header {
            width: 90%;
            padding-top: 0.8rem;
            padding-bottom: 1.1rem;
        }
    }

</style>
